import { make } from "vuex-pathify";

const state = {
  fatalError: {
    enabled: false,
    error: null,
  },
  user: null,
};

const mutations = make.mutations(state);

const actions = {
  ...make.actions(["user", "fatalError"]),

  raiseFatalError({ dispatch }, error) {
    dispatch("setFatalError", {
      enabled: true,
      error,
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
